import React, { Component } from "react";
import PropTypes from "prop-types";

import PortalWrapper from "./PortalWrapper";

import styles from "./AnchoredPortal.module.scss";

class AnchoredPortal extends Component {
  static propTypes = {
    children: PropTypes.node.isRequired
  };

  state = {
    anchored: false
  };

  componentDidMount() {
    this.setState({ anchored: true });
  }

  _renderContent() {
    const { children } = this.props;

    const { height, left, top, width } = this._anchor.getBoundingClientRect();
    const style = {
      position: "fixed",
      height,
      left,
      top,
      width,
      zIndex: 1000000
    };

    return (
      <PortalWrapper>
        <div style={style}>{children}</div>
      </PortalWrapper>
    );
  }

  render() {
    return (
      <div ref={ref => (this._anchor = ref)} className={styles.expando}>
        {this._anchor && this._renderContent()}
      </div>
    );
  }
}

export default AnchoredPortal;
